<script setup lang="ts">
import Footer from "@/components/Footer.vue";
import {ref} from "vue";

const day = ref(0),
    month = ref(0),
    year = ref(0),
    rememberMe = ref(false),
    errorMessage = ref(''),
    emit = defineEmits(['ageVerified']);

if (localStorage.getItem('user_age'))
    emit('ageVerified', parseInt(localStorage.getItem('user_age')!));

const verifyAge = () => {
    if (day.value === 0 || month.value === 0 || year.value === 0) {
        errorMessage.value = 'Podaj prawidłową datę';
        return;
    }

    const age = calculateAge(
        year.value,
        month.value,
        day.value);

    if (age < 18) {
        errorMessage.value = 'Strona przeznaczona tylko dla osób 18+';
    } else {
        errorMessage.value = '';
        if (rememberMe.value) {
            localStorage.setItem('user_age', age.toString());
        }

        console.log('Wiek to:', age);
        emit('ageVerified', age);
    }
}

const calculateAge = (y: number, m: number, d: number) => {
  const birthday = new Date(y, m - 1, d);
    const ageDifMs = Date.now() - birthday.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
}
</script>

<template>
    <div id="age_verification" class="w-full">
        <div class="container mx-auto text-center p-4 py-8">
            <h1 class="text-5xl">Podaj swoją<br/> datę urodzenia</h1>
            <div class="flex flex-col gap-4 pt-4 pb-8 px-7">
                <div class="error-label text-sm" v-show="errorMessage">{{ errorMessage}}</div>
                <select class="appearance-none block w-full p-1"
                        id="day"
                        v-model="day"
                >
                    <option value="0">DD</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                </select>
                <select class="appearance-none block w-full p-1"
                        id="month"
                        v-model="month"
                >
                        <option value="0">MM</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
            </select>
                <select  class="appearance-none block w-full p-1"
                         id="year"
                         v-model="year"
                >
                    <option value="0">YYYY</option>
                    <option value="2025">2025</option><option value="2024">2024</option><option value="2023">2023</option><option value="2022">2022</option><option value="2021">2021</option><option value="2020">2020</option><option value="2019">2019</option><option value="2018">2018</option><option value="2017">2017</option><option value="2016">2016</option><option value="2015">2015</option><option value="2014">2014</option><option value="2013">2013</option><option value="2012">2012</option><option value="2011">2011</option><option value="2010">2010</option><option value="2009">2009</option><option value="2008">2008</option><option value="2007">2007</option><option value="2006">2006</option><option value="2005">2005</option><option value="2004">2004</option><option value="2003">2003</option><option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option>
                </select>
                <div class="flex gap-2 mx-auto">
                    <input type="checkbox"
                           id="remember_me"
                           v-model="rememberMe"
                           class="w-4 h-4 bg-kozel-white shrink-0"
                    />
                    <label for="remember_me" class="text-sm">Zapamiętaj mój wiek</label>
                </div>
            </div>
            <button @click.prevent="verifyAge" class="block text-2xl">WEJDŹ<br/> NA STRONĘ</button>
            <Footer/>
        </div>
    </div>
</template>

<style scoped>
#age_verification {
    background-image: url("../assets/images/backgrounds/bg-age-verification.webp");
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    min-height: 100vh;
}

input {
    background: var(--color-kozel-white);
    font-size: 2rem;
    padding-top: 0.75rem;
    padding-inline: 1rem;
}

input::placeholder {
    color: #000;
    text-align: center;
}

input[type=checkbox] {
    padding: 0.15rem;
}

input[type="checkbox"]::before {
    background-color: var(--color-kozel-brown);
}

button {
    background: var(--color-kozel-brown);
    font-weight: 400;
    padding: 0.75rem 4rem 0.5rem;
}

select {
    background: var(--color-kozel-white);
    text-align: -webkit-center;
    text-align-last: center;
    margin: auto;
    width: 100%;
    font-size: 1.5rem;
    padding-top: 0.6rem;
    max-width: 50rem;
}

label, .error-label {
    font-family: 'ApexSerif', 'serif';
    font-weight: 700;
}
</style>